module.exports = __webpack_public_path__ + "img/9_48.d2715b67.png";